import React, { FC, MouseEvent } from "react";

import { AIAvatar } from "~/ui";

type PropsType = {
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
};

export const FloatingChatIcon: FC<PropsType> = ({ onClick }: PropsType) => {
  return (
    <button
      onClick={onClick}
      type="button"
      className="!fixed z-modal bottom-24 miniTablet:bottom-5 left-0 mx-4 miniTablet:ml-0 miniTablet:left-4 bg-primary-600 rounded-full"
    >
      <AIAvatar type="neutralExpression" size="md" />
    </button>
  );
};
